var map = {
	"./18.png": "f000",
	"./19.png": "c070",
	"./21.png": "9c84",
	"./bank.png": "7620",
	"./danger.png": "9f77",
	"./email.png": "9afb",
	"./flag-br-2.png": "3f59",
	"./flag-br-3.png": "0f8a",
	"./flag-br-50.png": "861e",
	"./flag-br-500.png": "41e6",
	"./flag-br-51.png": "fe95",
	"./flag-br-52.png": "cf85",
	"./flag-br-53.png": "6129",
	"./flag-br-54.png": "d009",
	"./flag-br-55.png": "7ccb",
	"./flag-br-56.png": "cc0a",
	"./flag-br-57.png": "223b",
	"./flag-br-58.png": "36a4",
	"./flag-br-59.png": "b9ef",
	"./flag-br-60.png": "a0de",
	"./flag-br.png": "7de4",
	"./flag-ca-50.png": "ebb5",
	"./flag-ca-60.png": "d710",
	"./flag-ca-on-50.png": "f4b3",
	"./flag-ca-on.png": "a0fc",
	"./flag-ca.png": "ecfd",
	"./flag-in-cricket-50.png": "738d",
	"./flag-in-cricket.png": "c4db",
	"./flag-in.png": "67ef",
	"./flag-mx.png": "c4c2",
	"./flag-ng-50.png": "8615",
	"./flag-ng-60.png": "5c2d",
	"./flag-ng.png": "8106",
	"./flag-pe-50.png": "aaed",
	"./flag-pe-60.png": "f7e2",
	"./flag-pe.png": "aa2b",
	"./mfb-logo.png": "d15e",
	"./secure.png": "6822",
	"./tick.png": "2bd4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";